/**
 * 共通カード（surface に subtle border + soft shadow）。
 *
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business voice-enrollment Web の各画面で共通利用するカードレイアウト
 * @graph-connects none
 */

import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** padding を抜く（独自レイアウト用） */
  bare?: boolean;
}

/**
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business 共通カードコンポーネント。背景・境界・余白・影をデザイントークンから引く
 * @graph-connects none
 */
export function Card({ children, bare = false, className = '', ...rest }: CardProps): ReactNode {
  return (
    <div
      className={[
        'mx-auto w-full max-w-2xl',
        'rounded-[var(--radius-2xl)]',
        'bg-[var(--color-bg-surface)]',
        'ring-1 ring-[var(--color-border)]',
        'shadow-[var(--shadow-lg)]',
        'backdrop-blur-sm',
        bare ? '' : 'p-8 sm:p-10',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
}
